import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID
}

let app

if (!firebase.apps.length) {
    app = firebase.initializeApp(firebaseConfig)
} else {
    app = firebase.app()
}

firebase
    .firestore()
    .enablePersistence()
    .then(() => {
        console.log('success')
    })
    .catch((err) => {
        if (err.code == 'failed-precondition') {
            console.log('multiple tab opened')
        } else if (err.code == 'unimplemented') {
            console.log('browser not supported')
        }
    })

export const getTimeStamp = () =>
    firebase.firestore.FieldValue.serverTimestamp()

export const DB = firebase.firestore()

export const REAL_DB = firebase.database()

export default app
